module.exports = __webpack_public_path__ + "img/avatar.a476f710.png";